import { useNavigate } from 'react-router-dom';

/**
 * "Contact Page" admin tab: a singleton (one /contact page), so this tab is
 * just an index card linking to the dedicated full-viewport WYSIWYG route
 * (see ../ContactPageEditor.jsx).
 */
export default function ContactPageTab() {
  const navigate = useNavigate();

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>Contact Page</h2>
          <p className="admin-panel__desc">
            The fully inline-editable <strong>/contact</strong> page (hero text, and every lead-capture form
            field — label, type, placeholder, required, dropdown options, add/remove). Use <strong>Edit</strong>{' '}
            for on-page WYSIWYG editing.
          </p>
        </div>
      </div>

      <div className="admin-list">
        <div className="admin-list-item">
          <div>
            <strong>Contact Us</strong>
            <br />
            <a href="/contact" target="_blank" rel="noopener noreferrer">
              /contact
            </a>
          </div>
          <div className="admin-list-actions">
            <button
              type="button"
              className="admin-btn admin-btn--ghost admin-btn--sm"
              onClick={() => navigate('/admin/contact-page/edit')}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
